const Hero = () => {
  return (
    <section className="hero-section">
      <img
        src="https://cdn.game.net/image/upload/f_auto,q_auto/v1/game_img/merch2021/Loyalty/Uncharted/Uncharted-Comp-P2-db.jpg"
        alt="hero-image"
      />
    </section>
  );
};

export { Hero };
